/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ApiTableEvent*`'s.
 */
export type ApiTableEvent =
  | ApiTableEventLoading
  | ApiTableEventPageNext
  | ApiTableEventPagePrevious
  | ApiTableEventPageSize;

/**
 * The API Table loading event type.
 */
export type ApiTableEventLoading = typeof API_TABLE_EVENT_LOADING;

/**
 * The API Table page next event type.
 */
export type ApiTableEventPageNext = typeof API_TABLE_EVENT_PAGE_NEXT;

/**
 * The API Table page previous event type.
 */
export type ApiTableEventPagePrevious = typeof API_TABLE_EVENT_PAGE_PREVIOUS;

/**
 * The API Table page size event type.
 */
export type ApiTableEventPageSize = typeof API_TABLE_EVENT_PAGE_SIZE;

/**
 * The API Table loading event constant.
 */
export const API_TABLE_EVENT_LOADING = `loading`;

/**
 * The API Table page next event constant.
 */
export const API_TABLE_EVENT_PAGE_NEXT = `pageNext`;

/**
 * The API Table page previous event constant.
 */
export const API_TABLE_EVENT_PAGE_PREVIOUS = `pagePrevious`;

/**
 * The API Table page size event constant.
 */
export const API_TABLE_EVENT_PAGE_SIZE = `pageSize`;
